"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeneralControls = void 0;
const UiElements_1 = require("../../ui/UiElements");
class GeneralControls {
    constructor(parentEl) {
        if (!parentEl) {
            throw new Error("Parent element (generalControl) is undefined");
        }
        const title = this.createTitle();
        const element = this.createElement();
        parentEl.append(title.domEl, element.domEl);
    }
    dispose() {
        delete this.gridBtn;
        delete this.axesBtn;
    }
    createTitle() {
        return new UiElements_1.DivEl()
            .setClass('module-title')
            .setId('generalTitle')
            .addAttribute('data-i18n-key', 'GENERAL');
    }
    createElement() {
        this.gridBtn = new UiElements_1.CheckboxEl(false);
        this.axesBtn = new UiElements_1.CheckboxEl(false);
        const gridLabel = this.createLabelElFor(this.gridBtn, 'GRID');
        const axesLabel = this.createLabelElFor(this.axesBtn, 'AXES');
        return new UiElements_1.DivEl()
            .setId('generalControls')
            .setClass('controls')
            .addChild(gridLabel)
            .addChild(axesLabel);
    }
    createLabelElFor(checkboxEl, tooltip) {
        return new UiElements_1.LabelEl('')
            .setClass('icon')
            .addChild(checkboxEl)
            .addAttribute('data-i18n-attr', `data-title=${tooltip}`)
            .addChild(new UiElements_1.IconEl(tooltip.toLowerCase()));
    }
}
exports.GeneralControls = GeneralControls;
